var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVertical = function SvgVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h5v72H4a4 4 0 0 1-4-4zM11 0h17v72H11z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 8,
    x: 32,
    y: 4,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    x: 32,
    y: 16,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 17,
    x: 59,
    y: 16,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 23,
    x: 32,
    y: 37,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 4,
    x: 32,
    y: 64,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 6,
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 13,
    y: 6,
    rx: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 18,
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 13,
    y: 12,
    rx: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 26,
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 13,
    y: 18,
    rx: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 34,
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 13,
    y: 24,
    rx: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 42,
    rx: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 13,
    y: 30,
    rx: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 8,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 8,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 8,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 8,
    r: 2
  })));
};
export default SvgVertical;